import styled from 'styled-components'
import { GIVONIC, INTER } from '@styles/fonts'
import { BLACK, AMBER_500, NEUTRAL_100, AMBER_400, GRAYSCALE_500 } from '@styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px 16px 16px;
  gap: 24px;
  overflow-y: auto;
`

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = styled.span`
  font-family: ${GIVONIC.bold};
  font-size: 18px;
  color: ${BLACK};
  margin: 0 0 -4px 0;
`

export const Description = styled.span`
  font-family: ${INTER.light};
  font-size: 14px;
  color: ${BLACK};
  opacity: 0.6;
  margin: 0;
`

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
  padding: 16px;
`

export const AlertSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const AlertIcon = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
`

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`

export const AlertTitle = styled.div`
  font-family: ${INTER.bold};
  font-size: 14px;
  color: ${AMBER_400};
`

export const AlertList = styled.ul`
  font-family: ${INTER.regular};
  font-size: 12px;
  color: ${GRAYSCALE_500};
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const ButtonWrapper = styled.div`
  padding: 16px;
`
